import {NoOperation} from '@/library/utils';
import store from '@/store';
import {type Directive, type DirectiveBinding} from 'vue';

function create(element: HTMLElement, directiveOptions: DirectiveBinding, vnode: any)
{
    if (false !== directiveOptions.value)
    {
        element.addEventListener('click', (event) =>
        {
            event.preventDefault();

            let lightBoxAssignment: Nullable<string> = element.getAttribute('x-light-box');

            let data: { images: LightBoxImageData[], current: number };
            if (lightBoxAssignment)
            {
                data = parseData(document.querySelectorAll('[x-light-box="' + lightBoxAssignment + '"]'), element);
            }
            else
            {
                data = parseData([element], element);
            }

            store.dispatch('lightBox/open', data).then(NoOperation);
        });
        element.classList.add('pointer');
    }
}

function parseData(elements: HTMLElement[] | NodeListOf<HTMLElement>, current: HTMLElement)
{
    let images: LightBoxImageData[] = [];
    let currentIndex: number        = 0;
    for (let index in elements)
    {
        if (elements.hasOwnProperty(index))
        {
            let element                       = elements[index];
            let src: Nullable<string>         = element.getAttribute('data-large-src') || null;
            let description: Nullable<string> = element.getAttribute('data-description') || element.getAttribute('alt') || element.getAttribute('title');

            if (!src)
            {
                // use image as fallback src
                if (element instanceof HTMLImageElement)
                {
                    src = element.getAttribute('src');
                }

                // try to find a 'a'-tag for big image
                let parent: HTMLElement = element;
                while (parent && !(parent instanceof HTMLBodyElement))
                {
                    if (parent instanceof HTMLAnchorElement)
                    {
                        src = parent.href;
                        break;
                    }

                    parent = parent.parentNode as HTMLElement;
                }
            }

            // still no src? error.
            if (!src)
            {
                throw new Error('Can\'t determinate image source.');
            }
            images.push({
                src,
                description,
                element,
            });

            if (element === current)
            {
                currentIndex = images.length;
            }
        }
    }

    return {
        images,
        current: currentIndex,
    };
}

const lightBox: Directive = {
    mounted: create,
};

export default lightBox;